<template>
  <base-modal class="modal-teacher" :title="`Edit ${labelMediaType}`" @close="$emit('close')">
    <form class="modal-teacher__form" @submit.prevent="save" data-test-id="teacher-media-form">
      <form-control :label="`UPLOAD ${labelMediaType}`" theme="dark" required data-test-id="upload-label">
        <file-input v-model="model.file" data-test-id="file-input"></file-input>
      </form-control>

      <h3 data-test-id="actual-media-header">Actual Profile {{ labelMediaType }}:</h3>
      <div class="modal-teacher__profile-media" data-test-id="profile-media">
        <img
          v-if="mediaType === 'profile_image'"
          :src="teacherProfile.profile_image_url"
          data-test-id="profile-image"
        />
        <video v-else width="100%" height="240" controls data-test-id="profile-video">
          <source :src="teacherProfile.video_url" type="video/mp4" />
        </video>
      </div>

      <div class="modal-teacher__submit">
        <p v-if="errors.length" data-test-id="error-message">{{ errors }}</p>
        <voxy-button
          view="primary"
          type="submit"
          size="s"
          :disabled="$v.model.$invalid || isSaving"
          data-test-id="submit-button"
        >
          {{ isSaving ? 'Saving...' : 'Upload' }}
        </voxy-button>
      </div>
    </form>
  </base-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { VoxyButton } from '@voxy-team/vue-voxy';
import { required } from 'vuelidate/lib/validators';

import FormErrorMapper from '@/mixins/FormErrorMapper';
import FileInput from '@/components/FileInput';
import BaseModal from '@/components/BaseModal';
import FormControl from '@/components/form/FormControl';

export default {
  name: 'ModalTeacherMedia',

  components: {
    BaseModal,
    FormControl,
    VoxyButton,
    FileInput,
  },

  mixins: [FormErrorMapper],

  props: {
    teacherProfile: {
      default: () => ({}),
      required: true,
      type: Object,
    },
    mediaType: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      errors: {},
      isSaving: false,
      labelMediaType: this.mediaType === 'profile_image' ? 'Photo' : 'Video',
      model: {
        file: null,
      },
    };
  },

  validations: {
    model: {
      file: {
        required,
      },
    },
  },

  methods: {
    ...mapActions('manageTeachers', {
      updateTeacherMediaProfile: 'UPDATE_TEACHER_MEDIA_PROFILE',
    }),

    async save() {
      this.errors = {};

      try {
        await this.updateTeacherMediaProfile({
          teacherHashEmail: this.$route.params.teacherHashEmail,
          value: this.model,
          mediaType: this.mediaType,
        });
        this.$emit('close');
      } catch (errors) {
        this.errors = JSON.stringify(errors);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/components/teacher-management-sections';

::v-deep .file-input__filename {
  color: white;
  font-size: 14px;
}

.file-input__empty {
  font-size: 14px;
}
</style>
